<template>
  <div class="homepage">
    <myheadBlock></myheadBlock>　
    <div class="hometiebox">
      <div class="hometieboximg">
        <img src="~assets/images/reg/bg2.jpg" alt="" />
      </div>
      　
      <div class="regbox">
        <div class="regtextbox">登记注册铁人</div>
        　
        <div class="regitem2" v-if="isRegType == 0">
          <div class="reginput">
            <p>
              姓&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;名
            </p>
            <div class="reginputbox">
              <div class="reginput1icon">
                <!-- <img src="~assets/images/reg/iconphone.png" alt="" /> -->
              </div>
              <input
                type="text"
                placeholder="请输入姓名"
                v-model="formData.nickName"
              />
            </div>
          </div>
          　
          <div class="reginput">
            <p>
              性&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;别
            </p>
            <div class="reginputbox">
              <div class="reginput1icon">
                <!-- <img src="~assets/images/reg/iconphone.png" alt="" /> -->
              </div>
              <select class="sexbox" v-model="formData.userGender">
                <option value="male">男</option>
                <option value="female">女</option>
              </select>
            </div>
          </div>
          　
          <div class="reginput">
            <p>出&nbsp;&nbsp;生&nbsp;&nbsp;日&nbsp;&nbsp;期</p>
            <div class="reginputboxyear">
              <p>年</p>
              <select
                id="year"
                v-model="formData.selectedYear"
                @change="updateDays"
              >
                <option v-for="year in years" :key="year" :value="year">
                  {{ year }}
                </option>
              </select>
              <p>月</p>
              <select
                id="month"
                v-model="formData.selectedMonth"
                @change="updateDays"
              >
                <option
                  v-for="month in months"
                  :key="month.value"
                  :value="month.value"
                >
                  {{ month.text }}
                </option>
              </select>
              <p>日</p>
              <select id="day" v-model="formData.selectedDay">
                <option v-for="day in days" :key="day" :value="day">
                  {{ day }}
                </option>
              </select>
            </div>
          </div>
          　
          <div class="reginput">
            <p>国&nbsp;&nbsp;籍&nbsp;/地&nbsp;&nbsp;区</p>
            <div class="reginputboxyear">
              <p style="width: 4vw">国家</p>
              <select
                id="year"
                v-model="formData.countryName"
                @change="updataCountry"
              >
                <option
                  v-for="country in CountryList"
                  :key="country.abbr"
                  :value="country.chinese"
                >
                  {{ country.chinese }} ({{ country.english }})
                </option></select
              >　
              <p v-if="isChinaSelected">省</p>
              <select
                v-if="isChinaSelected"
                id="Province"
                v-model="formData.stationName"
                @change="updateProvince"
              >
                <option
                  v-for="province in ProvinceList"
                  :key="province.name"
                  :value="province.name"
                >
                  {{ province.name }}
                </option>
              </select>
              <p v-if="isChinaSelected">市</p>
              <select
                v-if="isChinaSelected"
                id="City"
                v-model="formData.cityName"
                @change="updateCity"
              >
                <option
                  v-for="city in CityList"
                  :key="city.name"
                  :value="city.name"
                >
                  {{ city.name }}
                </option>
              </select>
            </div>
          </div>
          　
          <div class="reginput">
            <p>所&nbsp;属&nbsp;俱&nbsp;乐&nbsp;部</p>
            <div class="reginputbox">
              <div class="reginput1icon">
                <!-- <img src="~assets/images/reg/iconphone.png" alt="" /> -->
              </div>
              <select
                class="sexbox"
                v-model="formData.clubName"
                @change="updateClub"
              >
                <option
                  v-for="club in Clubdata"
                  :key="club.id"
                  :value="club.clubName"
                >
                  {{ club.clubName }}
                </option>
              </select>
            </div>
          </div>
          　
          <div class="reginput">
            <p>证&nbsp;&nbsp;件&nbsp;&nbsp;类&nbsp;&nbsp;型</p>
            <div class="reginputbox">
              <div class="reginput1icon">
                <!-- <img src="~assets/images/reg/iconphone.png" alt="" /> -->
              </div>
              <select class="sexbox" v-model="formData.documentType">
                <option value="id_card">身份证</option>
                <option value="passport">护照</option>
              </select>
            </div>
          </div>
          　
          <div class="reginput">
            <p>证&nbsp;&nbsp;件&nbsp;&nbsp;号&nbsp;&nbsp;码</p>
            <div class="reginputbox">
              <div class="reginput1icon">
                <img src="~assets/images/reg/icocard.png" alt="" />
              </div>
              <input
                type="text"
                placeholder="请输入证件号"
                v-model="formData.documentNumber"
              />
            </div>
          </div>
          　
          <div class="reginput reginputupimgbox">
            <p>完赛证明上传</p>
            <div class="reginputbox reginput2">
              <div class="reginput1icon">
                <img src="~assets/images/reg/icocard.png" alt="" />
              </div>
              <input
                type="text"
                placeholder="上传任一场铁人三项比赛完赛证明"
                v-model="formData.documentNumber2"
                disabled
                value="上传任一场铁人三项比赛完赛证明"
              />　
              <input
                type="file"
                id="file"
                ref="fileInput"
                @change="handleFileChange"
                style="display: none"
              />
              <button @click="openFilePicker" :disabled="isupimging">
                {{ isupimging ? "上传中..." : "上传" }}</button
              >　
              <div class="regupimg">
                <img src="~assets/images/reg/upimg.png" alt="" />
              </div>
              <div class="regupimgdone">
                <img id="upimgdoneurl" :src="UPimageSrc" alt="" />
              </div>
            </div>
          </div>
          　
          <div class="regfiletitle">隐私与协议</div>
          <div class="regfiletext1">用户协议勾选（必选）：</div>
          <div class="regfiletext2">
            <label style="display: flex; align-items: center">
              <input
                type="checkbox"
                v-model="selectedAgreement"
                class="regfilecheckbox"
              />
              “我已阅读并同意
              <a href="static/yonghu.txt" target="_blank">《用户服务协议》</a>
              及
              <a href="static/yinsi.txt" target="_blank">《隐私保护政策》</a>
              ，并授权平台按协议处理我的信息。”
            </label>
          </div>
          <div class="regfiletext2">
            <label style="display: flex; align-items: center">
              <input
                type="checkbox"
                v-model="selectedAgreement2"
                class="regfilecheckbox"
              />
              “我承诺所提交的所有信息及证明文件真实、完整，并同意平台核查。如存在虚假，自愿承担相应法律责任。”
            </label>
          </div>
          　
          <div
            class="regbtn"
            @click="handleregbtn"
            :class="[
              { disabled: isButton1Disabled },
              { disabledAgreement: !AgreementDisabled },
            ]"
          >
            <a href="javascript:void(0)">{{
              isButton1Disabled ? "提交中..." : "提交"
            }}</a>
          </div>
        </div>

        <div class="regitem3" v-if="isRegType == 1">
          <div class="regtitle">
            <p>已提交申请，待审核</p>
          </div>
          <div class="reginfo">
            <p>姓名：{{ userinfo.nickName }}</p>
            <p v-if="userinfo.userGender == 'male'">性别：男</p>
            <p v-if="userinfo.userGender == 'female'">性别：女</p>
            <p>出生日期：{{ userinfo.birthday }}</p>
            <p>国籍/地区：{{ userinfo.countryName }}</p>
            <p>所属俱乐部：{{ userinfo.clubName }}</p>
            <p v-if="userinfo.documentType == 'id_card'">证件类型：身份证</p>
            <p v-if="userinfo.documentType == 'passport'">证件类型：护照</p>
            <p>证件号码：{{ userinfo.documentNumber }}</p>
          </div>
        </div>

        <div class="regitem3" v-if="isRegType == 2">
          <div class="regtitle">
            <p>审核失败，请重新提交</p>
          </div>
          <div class="reginfo">
            <p>姓名：{{ userinfo.nickName }}</p>
            <p v-if="userinfo.userGender == 'male'">性别：男</p>
            <p v-if="userinfo.userGender == 'female'">性别：女</p>
            <p>出生日期：{{ userinfo.birthday }}</p>
            <p>国籍/地区：{{ userinfo.countryName }}</p>
            <p>所属俱乐部：{{ userinfo.clubName }}</p>
            <p v-if="userinfo.documentType == 'id_card'">证件类型：身份证</p>
            <p v-if="userinfo.documentType == 'passport'">证件类型：护照</p>
            <p>证件号码：{{ userinfo.documentNumber }}</p>
          </div>
          <div class="regbtn" @click="RegAgain">
            <a href="javascript:void(0)">重新提交</a>
          </div>
        </div>

        <div class="regitem3" v-if="isRegType == 3">
          <div class="regtitle">
            <p>已通过审核 认证铁人编号：{{ userinfo.ttNumber }}</p>
          </div>
          <div class="reginfo">
            <p>姓名：{{ userinfo.nickName }}</p>
            <p v-if="userinfo.userGender == 'male'">性别：男</p>
            <p v-if="userinfo.userGender == 'female'">性别：女</p>
            <p>出生日期：{{ userinfo.birthday }}</p>
            <p>国籍/地区：{{ userinfo.countryName }}</p>
            <p>所属俱乐部：{{ userinfo.clubName }}</p>
            <p v-if="userinfo.documentType == 'id_card'">证件类型：身份证</p>
            <p v-if="userinfo.documentType == 'passport'">证件类型：护照</p>
            <p>证件号码：{{ userinfo.documentNumber }}</p>
          </div>
        </div>
      </div>
    </div>
    　
    <footerBlock></footerBlock>
  </div>
</template>
//
<script>
import footerBlock from "./../components/block/footer";
import myheadBlock from "./../components/block/myhead";
import countriesData from "@/assets/json/countries.json";
import ProvinceData from "@/assets/json/Province.json";
import axios from "axios"; // 导入 Axios
import OSS from "ali-oss";
export default {
  name: "RegTiePage",
  data() {
    return {
      msg: "",
      response: null, // 存储服务器返回的数据
      error: null, // 存储请求错误信息
      userinfo: {},
      formData: {
        nickName: "", // 用户名（手机号或邮箱）
        userGender: "male",
        selectedYear: "2025", // 选中的年份
        selectedMonth: "01", // 选中的月份
        selectedDay: "1", // 选中的日期
        countryName: "中国", // 选中的国家
        countryId: "86",
        stationName: "北京", // 选中的省份
        stationId: "1",
        cityName: "北京", // 选中的城市
        cityId: "1",
        clubName: "动境俱乐部", // 选中的俱乐部
        clubId: "1",
        documentType: "id_card", // 选中的
        documentNumber: "", // 选中的
        documentNumber2: "", // 选中的
      },
      selectedAgreement: false, // 选中的
      selectedAgreement2: false, // 选中的
      isRegType: 0, //0 未注册1已注册待审核3审核通过
      years: [], // 动态生成的年份列表
      months: [
        // 固定的月份列表
        { value: "01", text: "1 月" },
        { value: "02", text: "2 月" },
        { value: "03", text: "3 月" },
        { value: "04", text: "4 月" },
        { value: "05", text: "5 月" },
        { value: "06", text: "6 月" },
        { value: "07", text: "7 月" },
        { value: "08", text: "8 月" },
        { value: "09", text: "9 月" },
        { value: "10", text: "10 月" },
        { value: "11", text: "11 月" },
        { value: "12", text: "12 月" },
      ],
      days: [], // 动态生成的日期列表
      CountryList: countriesData, // 国家列表
      ProvinceList: ProvinceData, // 省份列表
      CityList: [], // 城市列表
      Clubdata: [
        {
          id: "1",
          clubNumber: "10001",
          clubName: "动境俱乐部",
          clubContact: "联系人",
          userEmail: "aaates@gmail.com",
          userPhone: "13310012222",
          remark: null,
        },
        {
          id: "2",
          clubNumber: "10002",
          clubName: "澳大利亚俱乐部",
          clubContact: "联系人",
          userEmail: "aaates@gmail.com",
          userPhone: "13310012222",
          remark: null,
        },
        {
          id: "3",
          clubNumber: "10000",
          clubName: "无",
          clubContact: "联系人",
          userEmail: "aaates@gmail.com",
          userPhone: "13310012222",
          remark: null,
        },
      ],
      CardType: [
        {
          id: "id_card",
          cardType: "身份证",
        },
        {
          id: "passport",
          cardType: "护照",
        },
      ],
      ReviewStatus: {
        new_user: "新用户",
        awaiting_review: "已提交申请，待审核",
        fail_review: "审核失败",
        register: "认证铁人",
      },
      credentials: null, // 存储临时凭证
      uploadStatus: "", // 上传状态或结果提示
      selectedFile: null, // 存储用户选择的文件对象
      response: null, // 存储服务器返回的数据
      error: null, // 存储请求错误信息
      isupimging: false,
      UPimageSrc: "",
      isButton1Disabled: false,
      token: "",
      // AgreementDisabled:false
    };
  },
  components: {
    footerBlock,
    myheadBlock,
  },
  watch: {
    // selectedAgreement: function() {
    //   this.AgreementDisabled = !this.selectedAgreement;
    // },
    // selectedAgreement2: function() {
    //   this.AgreementDisabled = !this.selectedAgreement2;
    // }
  },
  computed: {
    // swiper() {
    //   return this.$refs.mySwiper.swiper;
    // }
    isChinaSelected() {
      // 判断是否选择了中国
      return this.formData.countryName === "中国";
    },
    AgreementDisabled() {
      // 动态计算 AgreementDisabled
      return this.selectedAgreement && this.selectedAgreement2;
    },
  },
  methods: {
    gotoHomePage: function () {
      this.$router.push({
        name: "Index",
      });
    },
    gotoMyPage: function () {
      this.$router.push({
        name: "mypage",
      });
    },
    gotoSetPage: function () {
      this.$router.push({
        name: "Setpage",
      });
    },
    gotoRankPage: function () {
      this.$router.push({
        name: "Rankpage",
      });
    },
    handleregbtn: function () {
      console.log("handleregbtn");
      this.sendloginPostRequest();
    },
    RegAgain: function () {
      console.log("RegAgain");
      this.isRegType = 0;
    },
    async CheckUserPostRequest() {
      // console.log(this.token);
      try {
        // 清空之前的响应和错误信息
        this.response = null;
        this.error = null;
        const url = " https://ttserver.aizhuotice.online/api/v1/userInfo";
        const response = await axios.get(url, {
          headers: {
            "Content-Type": "application/json",
            token: this.token,
          },
        });
        // 处理成功响应
        this.response = response.data; // 将返回的数据存储到组件状态
        console.log(this.response);
        if (this.response.code == 200) {
          this.userinfo = this.response.data;
          console.log(this.userinfo);
          console.log(this.userinfo.status);
          // console.log(this.userinfo.documentNumber);
          // console.log(this.userinfo.documentNumber.length);

          if (this.userinfo.status == "new_user") {
            this.isRegType = 0;
          }
          if (this.userinfo.status == "awaiting_review") {
            this.isRegType = 1;
          }
          if (this.userinfo.status == "fail_review") {
            this.isRegType = 2;
          }
          if (this.userinfo.status == "register") {
            this.isRegType = 3;
          }
        }
        if (this.response.code == 4011) {
          // alert(this.response.message);
          this.token = "";
          localStorage.setItem("token", "");
          alert("请先登录");
          this.gotoHomePage();
        }
      } catch (err) {
        // 处理请求错误
        if (err.response) {
          // 服务器返回了错误响应（例如 4xx 或 5xx）
          this.error = `服务器错误: ${err.response.status} - ${err.response.statusText}`;
        } else if (err.request) {
          // 请求已发出，但没有收到响应
          this.error = "未收到服务器响应";
        } else {
          // 其他错误
          this.error = `请求失败: ${err.message}`;
        }
        console.log(this.error);
      }
    },
    async sendloginPostRequest() {
      try {
        if (this.isButton1Disabled) return;
        // 禁用按钮
        this.isButton1Disabled = true;
        // 清空之前的响应和错误信息
        this.response = null;
        this.error = null;
        // 验证用户输入
        if (
          !this.formData.nickName ||
          !this.formData.userGender ||
          !this.formData.selectedYear ||
          !this.formData.selectedMonth ||
          !this.formData.selectedDay ||
          !this.formData.countryName ||
          !this.formData.stationName ||
          !this.formData.cityName ||
          !this.formData.clubName ||
          !this.formData.documentType ||
          !this.formData.documentNumber ||
          !this.UPimageSrc
        ) {
          this.error = "";
          return;
        }

        if (this.formData.documentType == "id_card") {
          if (this.formData.documentNumber.length != 18) {
            alert("身份证号格式错误");
            return;
          }
        }
        this.formData.birthday =
          this.formData.selectedYear +
          "-" +
          this.formData.selectedMonth +
          "-" +
          this.formData.selectedDay;
        this.formData.imageUrl = this.UPimageSrc;
        this.formData.token = this.token;
        // 配置 POST 请求的 URL 和数据
        const url = "https://ttserver.aizhuotice.online/api/v1/review/userInfo";
        console.log(this.formData);
        // 发起 POST 请求
        const response = await axios.post(url, this.formData, {
          headers: {
            "Content-Type": "application/json",
            token: this.token,
          },
        });
        // 处理成功响应
        this.response = response.data; // 将返回的数据存储到组件状态
        console.log(this.response);
        if (this.response.code == 200) {
          alert("提交成功");
          // localStorage.setItem('token', this.response.data.token);
          this.gotoHomePage();
        }else{
          alert(this.response.msg);
        }
      } catch (err) {
        // 处理请求错误
        if (err.response) {
          // 服务器返回了错误响应（例如 4xx 或 5xx）
          this.error = `服务器错误: ${err.response.status} - ${err.response.statusText}`;
        } else if (err.request) {
          // 请求已发出，但没有收到响应
          this.error = "未收到服务器响应";
        } else {
          // 其他错误
          this.error = `请求失败: ${err.message}`;
        }
      } finally {
        // 无论成功或失败，都重新启用按钮
        this.isButton1Disabled = false;
      }
    },
    handlebacklogin: function () {
      console.log("handlebacklogin");
      //   this.showloginbox = true;
      //   this.showregbox = false;
    },
    updateDays() {
      // 根据年份和月份计算日期数量
      const year = parseInt(this.formData.selectedYear);
      const month = parseInt(this.formData.selectedMonth);
      // 使用 Date 对象计算某个月的最大天数
      const lastDayOfMonth = new Date(year, month, 0).getDate();
      // 更新日期列表
      this.days = [];
      for (let day = 1; day <= lastDayOfMonth; day++) {
        this.days.push(day);
      }
      //   console.log(this.days);
      // 如果选中的日期超出范围，则重置为最大日期
      if (this.formData.selectedDay > lastDayOfMonth) {
        this.formData.selectedDay = lastDayOfMonth;
      }
    },
    updataCountry() {
      const selectedCountry = this.CountryList.find(
        (country) => country.chinese === this.formData.countryName
      );
      if (selectedCountry) {
        const chinese = selectedCountry.chinese; // 获取中文名
        const code = selectedCountry.code; // 获取国家代码
        console.log("选中的国家:", chinese);
        console.log("国家代码:", code);
        this.formData.countryId = code;
      }
    },
    showProvince() {
      console.log(this.formData.countryName);
      return this.formData.countryName === "中国";
    },
    showCity() {
      return this.showProvince && this.formData.stationName;
    },
    updateProvince() {
      // 根据选中的省份代码，更新城市列表
      // console.log(this.formData.stationName);
      // console.log(this.ProvinceList[0].name);
      // console.log(this.ProvinceList[1].name);
      const code = this.findstationCodeByName(this.formData.stationName);
      console.log(code);
      this.formData.stationId = code;
      if (this.formData.stationName) {
        const stationName = this.ProvinceList.find(
          (province) => province.name === this.formData.stationName
        );
        console.log(stationName);
        this.CityList = stationName ? stationName.children : [];
        this.formData.cityName = ""; // 清空城市选择
      } else {
        this.CityList = []; // 清空城市列表
        this.formData.cityName = ""; // 清空城市选择
      }
    },
    getProvinceName(code) {
      // 根据省份代码获取省份名称
      const province = this.ProvinceList.find(
        (province) => province.code === code
      );
      return province ? province.name : "";
    },
    getCityName(code) {
      // 根据城市代码获取城市名称
      const city = this.CityList.find((city) => city.code === code);
      return city ? city.name : "";
    },
    findstationCodeByName(targetName) {
      // console.log(targetName);
      for (const item of this.ProvinceList) {
        if (item.name === targetName) {
          return item.code; // 找到匹配项，直接返回 code
        }
      }
      return null; // 如果找不到，返回 null
    },
    findCityCodeByName(data, targetName) {
      for (const item of data) {
        if (item.name === targetName) {
          return item.code; // 找到匹配项，直接返回 code
        }
      }
      return null; // 如果找不到，返回 null
    },
    updateCity() {
      // 根据选中的省份代码，更新城市列表
      // console.log(this.formData.cityName);
      const code = this.findCityCodeByName(
        this.CityList,
        this.formData.cityName
      );
      console.log(code);
      this.formData.cityId = code;
    },
    updateClub() {
      console.log(this.formData.clubName);
      const selectedCountry = this.Clubdata.find(
        (country) => country.clubName === this.formData.clubName
      );
      if (selectedCountry) {
        const chinese = selectedCountry.clubName; // 获取中文名
        const code = selectedCountry.id; // 获取国家代码
        console.log("选中的clue:", chinese);
        console.log("club代码:", code);
        this.formData.clubId = code;
      }
    },
    openFilePicker() {
      if (this.isupimging) {
        return;
      }
      this.$refs.fileInput.click(); // 触发隐藏的文件输入框
    },
    async testupfile() {
      try {
        if (!this.selectedFile) {
          this.message = "请先选择一个文件！";
          return;
        }
        this.isupimging = true;
        const client = new OSS({
          bucket: "tieren3", // 替换为你的 OSS Bucket 名称
          region: "oss-cn-beijing", // 替换为你的 OSS 区域
          accessKeyId: "LTAI5tG9Dtp6KecASCY1Mhri",
          accessKeySecret: "oo7N9qVPoP6pil4hzDMmPcdD1LrBB9",
        });
        // 执行文件上传
        const result = await client.put(
          this.selectedFile.name,
          this.selectedFile
        );
        console.log(result);
        this.uploadStatus = "文件上传成功！";
        this.showupimg(result.url);
      } catch (error) {
        this.uploadStatus = `上传失败: ${error.message}`;
        console.error(error);
      } finally {
        this.isupimging = false;
      }
    },
    showupimg(url) {
      console.log(url);
      this.UPimageSrc = url;
    },
    async reginput2sendbtn() {
      try {
        // 确保文件存在
        const file = this.$refs.fileInput.files[0];
        if (!file) {
          this.uploadStatus = "请选择一个文件！";
          return;
        }
        // 判断凭证是否过期，过期则重新获取
        if (this.isCredentialsExpired(this.credentials)) {
          this.credentials = await this.fetchStsToken();
        }
        //         AccessKey ID
        // LTAI5tG9Dtp6KecASCY1Mhri
        // AccessKey Secret
        // oo7N9qVPoP6pil4hzDMmPcdD1LrBB9
        // 初始化 OSS 客户端
        const client = new OSS({
          bucket: "userFeedback", // 替换为你的 OSS Bucket 名称
          region: "oss-cn-hangzhou", // 替换为你的 OSS 区域
          accessKeyId: this.credentials.AccessKeyId,
          accessKeySecret: this.credentials.AccessKeySecret,
          stsToken: this.credentials.SecurityToken,
        });
        // 执行文件上传
        const result = await client.put(file.name, file);
        console.log(result);
        this.uploadStatus = "文件上传成功！";
      } catch (error) {
        this.uploadStatus = `上传失败: ${error.message}`;
        console.error(error);
      }
    },
    /**
     * 获取临时 STS 凭证
     */
    async fetchStsToken() {
      const response = await fetch(
        "https://ttserver.aizhuotice.online/manage/v1/sts",
        {
          method: "GET",
        }
      );
      if (!response.ok) {
        throw new Error(
          `获取STS令牌失败: ${response.status} ${response.statusText}`
        );
      }
      return await response.json();
    },
    /**
     * 判断临时凭证是否到期
     */
    isCredentialsExpired(credentials) {
      if (!credentials) {
        return true;
      }
      const expireDate = new Date(credentials.Expiration);
      const now = new Date();
      // 如果有效期不足一分钟，视为过期
      return expireDate.getTime() - now.getTime() <= 60000;
    },
    // 监听文件选择事件
    handleFileChange(event) {
      // 获取用户选择的文件
      this.selectedFile = event.target.files[0];
      if (this.selectedFile) {
        console.log("已选择文件:", this.selectedFile.name);
        this.testupfile();
      } else {
        console.log("未选择文件");
      }
    },
    // 上传文件
    async uploadFile() {
      if (!this.selectedFile) {
        alert("请选择一个文件！");
        return;
      }
      // 创建FormData对象，用于存储文件数据
      const formData = new FormData();
      formData.append("file", this.selectedFile); // 'file'是字段名，需与后端保持一致
      formData.append("token", "1234567890");
      try {
        // 发送POST请求上传文件
        const response = await axios.post(
          "https://ttserver.aizhuotice.online/manage/v1/sts",
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data", // 设置请求头类型为表单数据
            },
          }
        );
        console.log("文件上传成功", response.data);
        alert("文件上传成功！");
      } catch (error) {
        console.error("文件上传失败", error);
        alert("文件上传失败，请稍后再试！");
      }
    },
    async GetstsToken() {
      try {
        // 清空之前的响应和错误信息
        this.response = null;
        this.error = null;
        // 验证用户输入
        // 配置 POST 请求的 URL 和数据
        const url = " https://ttserver.aizhuotice.online/manage/v1/sts";
        const postData = {
          token: this.token,
        };
        // 发起 POST 请求
        const response = await axios.post(url, postData);
        // 处理成功响应
        this.response = response.data; // 将返回的数据存储到组件状态
      } catch (err) {
        // 处理请求错误
        if (err.response) {
          // 服务器返回了错误响应（例如 4xx 或 5xx）
          this.error = `服务器错误: ${err.response.status} - ${err.response.statusText}`;
        } else if (err.request) {
          // 请求已发出，但没有收到响应
          this.error = "未收到服务器响应";
        } else {
          // 其他错误
          this.error = `请求失败: ${err.message}`;
        }
      }
    },
  },
  watch: {
    countryName(newVal) {
      // 当用户切换国家时，如果不是中国，清空省份和城市选择
      if (!this.isChinaSelected) {
        this.formData.stationName = "";
        this.formData.cityName = "";
        this.CityList = [];
      }
    },
  },
  mounted() {
    this.$nextTick(() => {
      window.scrollTo(0, 0); // 确保 DOM 渲染完成后滚动到顶部
      console.log("滚动到顶部");
    });
  },
  created() {
    // 初始化年份列表
    const currentYear = new Date().getFullYear();
    for (let year = currentYear; year >= 1900; year--) {
      this.years.push(year);
    }
    // 默认选中当前年份和月份
    this.formData.selectedYear = currentYear;
    this.formData.selectedMonth = "01";
    // 初始化日期列表
    this.updateDays();
    this.token = localStorage.getItem("token");
    if (!this.token) {
      alert("请先登录");
      this.gotoHomePage();
    } else {
      this.CheckUserPostRequest();
    }
  },
};
</script>



<style scoped>
h1,
h2 {
  font-weight: normal;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  display: inline-block;
  margin: 0 10px;
}

.hometiebox {
  width: 100vw;
  height: 120vw;
  position: relative;
}

.hometieboximg {
  width: 100%;
  height: 100%;
}

.hometieboximg img {
  width: 100%;
  height: 100%;
}

.hometiebtnimg {
  position: absolute;
  top: 37.5vw;
  left: 38vw;
  width: 25.5vw;
  height: 5.5vw;
}

.hometiebtnimg img {
  width: 100%;
  height: 100%;
}

.hometiebox2 {
  width: 100vw;
  height: 56.7vw;
  position: relative;
}

.hometielogo {
  position: absolute;
  width: 10vw;
  height: 10vw;
  top: 2vw;
  left: 45vw;
}

.hometielogo img {
  width: 100%;
  height: auto;
}

.regitem2 {
  position: absolute;
  top: 13vw;
  left: 15vw;
  width: 34vw;
  height: 3vw;
}

.reginput {
  position: relative;
  margin-bottom: 3vw;
  left: 0vw;
  width: 60vw;
  height: 3vw;
  display: flex;
  /* border: 1px solid #fff; */
  /* border-radius: 6px; */
  /* background-color: #fff; */
}

.reginputbox {
  position: relative;
  margin-top: 0vw;
  left: 0vw;
  width: 60vw;
  height: 3vw;
  display: flex;
  border: 1px solid #fff;
  border-radius: 6px;
  background-color: #fff;
}

.regitem2 input {
  /* padding-left: 5vw; */
  width: 100%;
  height: 100%;
  border: none;
  font-size: 22px;
  font-weight: bold;
  color: #000;
  display: flex;
  position: relative;
  border-radius: 6px;
}

.regitem2 input::placeholder {
  color: #aaa;
  font-size: 18px;
  font-weight: bold;
}

.reginput p {
  font-size: 22px;
  font-weight: bold;
  color: #fff;
  width: 18vw;
  margin-left: 0vw;
}

.reginput1icon {
  display: flex;
}

.regbox {
  position: absolute;
  width: 90vw;
  height: 100vw;
  top: 9vw;
  left: 5vw;
  background-color: rgba(0, 0, 0, 0.8);
  border-radius: 20px;
}

.regbox .regtextbox {
  top: 3vw;
  /* left: 15vw; */
  width: 100%;
  text-align: center;
  font-size: 40px;
  color: #a82024;
  font-weight: bold;
  position: absolute;
}

.regbox .codeloginbox {
  position: absolute;
  top: 3vw;
  left: 10vw;
  width: 100%;
  height: 100%;
}

.regbox .codeloginbox .regitem2 {
  top: 8vw;
}

.reginput3 {
  position: absolute;
  top: 10vw;
  left: 0vw;
  width: 34vw;
  height: 3vw;
  display: flex;
  border: 1px solid #fff;
  border-radius: 6px;
  background-color: #fff;
}

.regitem3 input {
  width: 100%;
  height: 100%;
  border: none;
  font-size: 22px;
  font-weight: bold;
  color: #000;
  display: flex;
  position: relative;
  border-radius: 6px;
}

.regitem3 input::placeholder {
  color: #aaa;
  font-size: 18px;
  font-weight: bold;
}

.reginput4 {
  position: absolute;
  top: 15vw;
  left: 0vw;
  width: 34vw;
  height: 3vw;
  display: flex;
  border: 1px solid #fff;
  border-radius: 6px;
  background-color: #fff;
}

.regitem4 input {
  width: 100%;
  height: 100%;
  border: none;
  font-size: 22px;
  font-weight: bold;
  color: #000;
  display: flex;
  position: relative;
  border-radius: 6px;
}

.regitem4 input::placeholder {
  color: #aaa;
  font-size: 18px;
  font-weight: bold;
}

.regtextbox2 {
  position: absolute;
  top: 70vw;
  left: 0vw;
  width: 50vw;
  height: 3vw;
  font-size: 18px;
  color: #aaa;
  font-weight: bold;
}

.regbox .regtextbox3 {
  position: absolute;
  top: 31vw;
  left: 15vw;
  width: 34vw;
  height: 4.5vw;
  font-size: 18px;
  color: #a82024;
  font-weight: bold;
}

.regbox .gotoreg {
  position: absolute;
  top: 0vw;
  right: 0vw;
}

.regbox .regtextbox3 a {
  color: #a82024;
}

.regbtn {
  position: absolute;
  top: 80vw;
  left: 0vw;
  width: 60vw;
  height: 4.5vw;
  font-size: 26px;
  font-weight: bold;
  color: #fff;
  background-color: #a82024;
  border-radius: 6px;
  text-align: center;
  line-height: 4.5vw;
}

.regbtn a {
  color: #fff;
}

.reginput .sexbox {
  width: 100%;
  height: 100%;
  border: none;
  font-size: 22px;
  font-weight: bold;
}

.reginputboxyear {
  position: relative;
  margin-top: 0vw;
  left: 0vw;
  width: 47vw;
  height: 3vw;
  display: flex;
  /* border: 1px solid #fff;
  border-radius: 6px;
  background-color: #fff; */
}

.reginputboxyear select {
  border: none;
  font-size: 22px;
  font-weight: bold;
  display: flex;
  width: 12.5vw;
  border-radius: 6px;
}

.reginputboxyear p {
  font-size: 22px;
  font-weight: bold;
  color: #fff;
  width: 3.5vw;
  text-align: center;
}

.reginput2sendbtn {
  position: absolute;
  top: 0vw;
  left: 34vw;
  width: 15vw;
  height: 3.5vw;
  font-size: 22px;
  font-weight: bold;
  color: #fff;
  background-color: #a82024;
  border-radius: 6px;
  text-align: center;
  line-height: 3.5vw;
}

.reginput2sendbtn a {
  color: #fff;
}

.reginput2 {
  position: absolute;
  top: 0vw;
  left: 13.5vw;
  width: 31vw;
  height: 3vw;
  display: flex;
  border: 1px solid #fff;
  border-radius: 6px;
  background-color: #fff;
}

.reginput2 button {
  position: absolute;
  top: 0vw;
  left: 32vw;
  width: 15vw;
  height: 3.5vw;
  font-size: 22px;
  font-weight: bold;
  color: #fff;
  background-color: #a82024;
  border-radius: 6px;
  text-align: center;
  line-height: 3.5vw;
}

.reginputupimgbox p {
  font-size: 20px;
  text-align: center;
  width: 11vw;
}

.regupimg {
  position: absolute;
  top: 5vw;
  left: 0vw;
  width: 45vw;
  height: 15vw;
}

.regupimg img {
  width: 100%;
  height: auto;
}

.regupimgdone {
  position: absolute;
  top: 5vw;
  left: 0vw;
  width: 12vw;
  height: 11.5vw;
  display: flex;
  /* 使用 Flexbox 让图片居中 */
  align-items: center;
  justify-content: center;
  overflow: hidden;
  /* 防止图片超出容器 */
  border: 0px solid #ccc;
  /* 可选：添加边框以便观察效果 */
}

.regupimgdone img {
  max-width: 100%;
  max-height: 100%;
  width: auto;
  height: auto;
  object-fit: contain;
  /* 确保图片完整显示并保持比例 */
}

.regfiletitle {
  font-size: 22px;
  text-align: left;
  width: 10vw;
  position: relative;
  color: #fff;
  top: 12vw;
  font-weight: bold;
}

.regfiletext1 {
  font-size: 16px;
  text-align: left;
  width: 20vw;
  position: relative;
  color: #fff;
  top: 13vw;
  font-weight: normal;
}

.regfiletext2 {
  font-size: 14px;
  text-align: left;
  width: 60vw;
  position: relative;
  color: #fff;
  top: 13vw;
  font-weight: normal;
  margin-top: 1vw;
}

.regfiletext2 .regfilecheckbox {
  width: 20px;
  height: 20px;
  border-radius: 50%;
  border: 1px solid #fff;
  margin-right: 1vw;
}
.regbtn.disabled {
  background-color: #ccc; /* 灰色背景表示禁用 */
  cursor: not-allowed; /* 鼠标悬停时显示“禁止”光标 */
  pointer-events: none; /* 禁用点击事件 */
}
.regbtn.disabled a {
  color: #666; /* 文字颜色变淡 */
}

.regbtn.disabledAgreement {
  background-color: #ccc; /* 灰色背景表示禁用 */
  cursor: not-allowed; /* 鼠标悬停时显示“禁止”光标 */
  pointer-events: none; /* 禁用点击事件 */
}
.regbtn.disabledAgreement a {
  color: #666; /* 文字颜色变淡 */
}
.regitem3 {
  position: absolute;
  top: 13vw;
  left: 15vw;
  width: 50vw;
  height: 3vw;
}

.regtitle {
  font-size: 2vw;
  color: #a82024;
  font-weight: bold;
  height: 5vw;
  line-height: 5vw;
  text-align: center;
}

.reginfo {
  position: relative;
}
.reginfo p {
  font-size: 1.5vw;
  color: #fff;
  font-weight: bold;
  height: 3vw;
  line-height: 3vw;
}
</style>



// WEBPACK FOOTER //
// src/components/RegTie.vue